import { useEffect, useRef, useState } from "react";
import { langState, langText } from "../recoil/lang";
import toast from "react-hot-toast";
import { useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import LogController from "../controller/LogController";

export const useBackTimer = (
  pageName: string,
  time?: number,
  handleGoBack?: () => void
) => {
  // 타이머 시간
  const restTime = time || 10 * 60 * 1000;
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const navigate = useNavigate();

  const lang = useRecoilValue(langState);

  // 시간 비교값
  const [inactiveTime, setInactiveTime] = useState<number>(0);

  // 타이머 초기화 함수
  const resetTimer = () => {
    setInactiveTime(0);
    if (timerRef.current) clearTimeout(timerRef.current);
    startTimer();
    if (handleGoBack) handleGoBack();
  };

  const startTimer = () => {
    timerRef.current = setTimeout(() => {
      setInactiveTime((prevTime) => prevTime + restTime);
    }, restTime);
  };

  useEffect(() => {
    resetTimer();
  }, []);

  useEffect(() => {
    console.log("timer init");

    if (inactiveTime >= restTime) {
      toast.error(langText.toast_back[lang]);
      navigate("/master");
      LogController.event({
        path: pageName,
        params: "timer",
        params2: `장시간 움직임이 없어 메인 페이지로 이동`,
      });
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [inactiveTime]);

  return { resetTimer };
};
